var AriesComponent = require('libs/aries-component');
var PageTakeover = require('libs/pageTakeover');
var LoadingIndicator = require('utils/loading-indicator');
var Widget = require('libs/widget-loader');
var ResponsiveUtils = require('utils/responsiveUtils');

var ResponsiveWidgetHandler = AriesComponent.extend({
  $activeContainer: '',
  isTakeOverActive: false,
  VIEWPORT: {
    TABLET_VIEWPORT: 601,
    DESKTOP_VIEWPORT: 770
  },
  /**
   * Creates responiveUtils instance and calls init function.
   */
  initResponsiveUtils: function(){
    this.responsiveUtils = ResponsiveUtils.create({
      resizeEventHandler: this.resizeEventHandler.bind(this),
      orientationChangeEventHandler: this.resizeEventHandler.bind(this),
      viewport: this.VIEWPORT
    });
    this.responsiveUtils.init();
  },
  /**
   * Handles Viewport resize, and conditions on which the takeover and collapsible should be removed or shown.
   */
  resizeEventHandler: function(){
    var $containerDOM = this.$activeContainer;
    if(!this.$activeContainer.length){
      return;
    }
    if(this.responsiveUtils.isMobileOrTablet()){
      if(this.isTakeOverActive){
        return;
      } else {
        this.isTakeOverActive = true;
        this.initPageTakeOver(this.$activeContainer.closest('.js-layout-container').find('.js-toggle-item'), this.$activeContainer, true);
      }
    } else {
      if(this.isTakeOverActive) {
        this.pageTakeOver.remove();
        this.isTakeOverActive = false;
        // resetting the active container, after removing takeover.
        this.$activeContainer = $containerDOM;
      } else {
        return;
      }
    }
  },
  /**
   * This function is called when toggle button is clicked.
   * It checks if container needs to be collapsed or expanded and call the functions
   * @param  {Event} event : contains reference of target clicked element
   */
  toggleItemHandler: function(event){
    var $target = $(event.currentTarget),
        $container = $target.closest('.js-layout-container').find('.js-target-container');

    event.preventDefault();
    if($target.hasClass('js-expand-item')){
      $container.removeClass('l-display-none');
      this.expandItemHandler(event, $target, $container);
    } else if($target.hasClass('js-collapse-item')) {
      this.collapseItemHandler(event, $target);
      $container.addClass('l-display-none');
      $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
      
      if(!$container.data('error')){
        $container.html('');
      }
    } else {
      return false;
    }
  },
  /**
   * Collapses the container by emptying its content and hiding takeover.
   * @param {jQuery DOM Object} $target : the target link which triggers the container to collapse
   */
  collapseItemHandler: function(event, $target){
    event.stopPropagation();
    event.preventDefault();
    //only in case of mobile or tablet viewport
    if(this.isTakeOverActive){
      this.pageTakeOver.hide();
    } 
    this.toggleIconClasses($target);
    
    this.$activeContainer = '';
  },
  /**
   * Expands the container by initiating a widget handler to get the required tile from server.
   * In case of mobile or tablet, first initiate a takeOver and then the widget handler.
   * @param {jQuery DOM Object} event : reference of click event 
   * @param {jQuery DOM Object} $target : the target link which triggers the container to expand
   * @param {jQuery DOM Object} $container : the container DOM where the contents should be injected
   */
  expandItemHandler: function(event, $target, $container){
  
    var $successContainer = this.$el.find('.js-success-message');
  
    if($successContainer.length && !$successContainer.hasClass('is-hidden')) {
      $successContainer.addClass('is-hidden');
    }
    
    event.preventDefault();
    this.isTakeOverActive = false;
    if(this.responsiveUtils.isMobileOrTablet()){
      this.isTakeOverActive = true;
      this.initPageTakeOver($target, $container, false);
    } else {
      this.initWidgetHandler($target, $container);
    }
  },
  /**
   * Initiate the page takeover in case of mobile and tablet viewport.
   * @param {jQuery DOM Object} $target : the target link which is clicked
   * @param {jQuery DOM Object} $container : the container DOM where contents should be injected
   * @param {Boolean} isResized : true, if viewport is resized.
   */
  initPageTakeOver: function($target, $container, isResized){
    var takeOverConfig = {
      $el: $container.closest('.js-layout-container'),
      isNotRetainDisplayAttribute: true,
      hidePageHeader: true
    }
    // in case of resize, dont need to initiate a widget handler
    if(isResized) {
      takeOverConfig.transition_speed = 0; 
    } else {
      takeOverConfig.beforeShow = this.initWidgetHandler.bind(this, $target, $container)
      takeOverConfig.afterHide = this.hideTakeOverHandler.bind(this, $container)
    }
    this.pageTakeOver = PageTakeover.create(takeOverConfig)
    this.pageTakeOver.init();
  },
  /**
   * Hides takeover contents after it is closed.
   * @param {jQuery DOM Object} $container : reference of container
   */
  hideTakeOverHandler: function($container){
    this.$activeContainer = '';
  },
  /**
   * Initiates the widget handler and loading indicator.
   * @param {jQuery DOM Object} $target : the target link which is clicked
   * @param {jQuery DOM Object} $container : the container DOM where contents should be injected
   */
  initWidgetHandler: function($target, $container){
    var loader = new LoadingIndicator($container);

    
    this.collapseActiveContainer(this.$activeContainer);
    this.toggleIconClasses($target);
    
    // displays loader
    if(!$container.data('error')) {
      //de-activates all other links while loading of widget
      this.unsubscribeDOMEvents();
      loader.addLoader();
      this.loadedComponent = new Widget({
        type: this.type,
        componentId: this.$el.data('component-id'),
        layout: $container,
        url: $target.data('url'),
        data: {
          context: this.getContextData(),
          sessionToken: this.getSessionToken(),
          sourceURI: this.getSourceURI()
        },
        success: this.onWidgetResponse.bind(this, $container, loader, $target),
        error: this.onWidgetResponse.bind(this, $container, loader, $target)
      });
    } else {
      this.$activeContainer = $container;
    }
  },
  /**
   * This function is called when a response is recieved from server on initiating  an AJAX call through widget handler
   * @param  {jQuery DOM Object} $container: reference of container
   * @param  {Object} loader : reference of loading spinner to be removed.
   */
  onWidgetResponse: function($container, loader, $target){
    // activates links after getting response
    this.subscribeDOMEvents();
    this.$activeContainer = $container;
    loader.removeLoader();
    window.$(this.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
  },
  /**
   * Collapse the active container before expanding other container.
   * The contents of current active container should be emptied out.
   * @param {jQuery DOM Object} $activeContainer : Contains reference of active Container.
   */
  collapseActiveContainer: function($activeContainer) {
    if($activeContainer.length) {
      if(!$activeContainer.data('error')){
        $activeContainer.html('');
      }
      $activeContainer.addClass('l-display-none');
      this.toggleIconClasses($activeContainer.closest('.js-layout-container').find('.js-toggle-item'));
    }
  },
  /**
   * Used for toggling icons for both mobile and desktop viewports
   * @param  {jQuery DOM Object} $target: target element clicked
   */
  toggleIconClasses: function($target){
    $target.find('.js-icon-mobile').toggleClass('t-icon-arrow-right t-icon-navigation-close');
    $target.find('.js-icon-desktop').toggleClass('t-icon-arrow-down t-icon-arrow-up');
    $target.toggleClass('js-expand-item js-collapse-item');
    if($(".t-icon-navigation-close").length && $(".t-icon-navigation-close").is(":visible")){
   		 $('.t-icon-navigation-close').attr('aria-label','close');
								if($('.l-res-button-timer-wrapper').length){
											$('.l-res-button-timer-wrapper').attr('aria-hidden',true)
								}
    }
    else{
    $('.t-icon-navigation-close').removeAttr('aria-label');
    if($('.l-res-button-timer-wrapper').length){
								$('.l-res-button-timer-wrapper').removeAttr('aria-hidden');
					}
    }
  }
});

module.exports = ResponsiveWidgetHandler;
